import React, { useEffect, useState } from "react";
import HoldingLine from "~components/Portfolio/PortfolioForm/HoldingLine";
import { usePortfolioPage } from "~context/PortfolioPageContext";
import { DEFAULT_PORTFOLIO_FORM } from "~constants/Portfolio";

export default function PortfolioHoldings() {
  const { portfolioForm, updatePortfolioForm } = usePortfolioPage();

  const [formData, setFormData] = useState(
    portfolioForm || DEFAULT_PORTFOLIO_FORM
  );

  useEffect(() => {
    if (!portfolioForm) {
      return;
    }

    setFormData(portfolioForm);
  }, [portfolioForm]);

  const removeHolding = (holdingIndex: number) => {
    const holdings = [...formData.holdings];

    holdings.splice(holdingIndex, 1);

    updatePortfolioForm({ ...formData, holdings });
  };

  const addLot = (holdingIndex: number) => {
    const holdings = [...formData.holdings];
    const holding = holdings[holdingIndex];

    holding.lots.push({
      lotId: -1,
      buyDate: Date.now(),
      shares: "0",
      buyPrice: "0",
    });

    holdings[holdingIndex] = holding;
    updatePortfolioForm({ ...formData, holdings });
  };

  return (
    <>
      {formData.holdings.map((holding, index) => (
        <HoldingLine
          key={`holding_${index}`}
          index={index}
          holding={holding}
          onRemove={removeHolding}
          onAddLot={addLot}
        />
      ))}
    </>
  );
}
